module.exports = __webpack_public_path__ + "media/customizations/riverstone/logo-new-b96950ac8d66a3eef1c6b77d13abf211.png";